import {useContext} from "react";
import FinCheckContext from "../../tools/contexts/finCheck/FincheckContext";
import {MdOutlineFactCheck} from "react-icons/md";
import Button from "../Button";

const WidgetCard = () => {
    const finCheckContext = useContext(FinCheckContext);
    return <div className="w-full bg-white p-5 rounded-lg flex flex-col">
        <div className="w-full flex flex-col mb-5 justify-center items-center">
            <div className="p-4 bg-green-50 mb-2 rounded-full">
                <MdOutlineFactCheck className="text-green-500 text-4xl"/>
            </div>
            <p className="mr-2 px-2 text-lg font-semibold">گواهی خوش حسابی بانکی ونیفای</p>
            <p className="text-center px-2 text-sm">افزونه خوش‌حسابی شما بر روی آگهی قرار گرفته است.</p>
        </div>
        <div className="w-full border-t py-3 flex items-center justify-between">
            <span className="text-sm ">چک برگشتی </span>
            <span
                className="text-sm font-semibold text-green-500">{finCheckContext.widget.widgets_body?.has_back_check ? 'دارد' : 'ندارد'}</span>
        </div>
        <div className="w-full border-t py-3 flex items-center justify-between">
            <span className="text-sm ">قسط پرداخت نشده</span>
            <span
                className="text-sm font-semibold text-green-500">{finCheckContext.widget.widgets_body?.has_expired_facility ? 'دارد' : 'ندارد'}</span>
        </div>
        <div className="w-full border-t py-3 flex items-center justify-between">
            <span className="text-sm ">صاحب گواهی</span>
            <span className="text-sm font-semibold text-green-500">آگهی گذار</span>
        </div>
        <div className="w-full border-t py-3 flex items-center justify-between">
            <span className="text-sm ">تاریخ گواهی</span>
            <span
                className="text-sm font-semibold text-yellow-700">{finCheckContext.widget.widgets_body?.inquiry_date}</span>
        </div>
        <div className="grid gap-2 pt-3 border-t grid-cols-2">
            <Button onClick={() => finCheckContext.handleRedirect()} rounded="rounded-lg" className="text-sm">بازگشت
                به دیوار</Button>
            <Button theme="red" onClick={() => finCheckContext.handleDeleteModal(finCheckContext.widget.pid)}
                    rounded="rounded-lg" className="text-sm">حذف افزونه</Button>
        </div>
    </div>
}
export default WidgetCard;